import styled from "styled-components";
import breakpoints from "utils/breakpoints";

export const DetailsContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 60%;
  display: inline-block;
`;

export const AnimalTraits = styled.div`
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  & h2 {
    margin-top: 0;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  cursor: pointer;
  width: 40%;
  display: inline-flex;
  justify-content: center;

  ${breakpoints.smMax`
    max-width: unset;
    width: 100%;
  `}
`;

export const AnimalName = styled.h2`
  display: flex;
  align-items: center;
  font-family: "Neucha", serif;
  font-size: 3em;
  margin-bottom: 1rem;
  flex: 100%;
  margin: 0;
`;

// Currently unused.
// export const AdoptionType = styled.p`
//   margin: 0;
//   flex: 100%;
//   display: flex;
//   align-items: unset;

//   & > i {
//     margin-left: 0.25rem;
//   }
// `;

export const AnimalBasicInfo = styled.div`
  display: flex;
  align-items: center;

  & > span {
    display: flex;
    margin-right: 1rem;
  }

  & > span > :first-child {
    margin-right: 0.25rem;
  }
`;

export const AnimalDescription = styled.p`
  flex: 1 1 100%;
`;

export const AnimalImageWrapper = styled.div`
  display: inline-block;
  border-radius: 0.5rem;
  overflow: hidden;

  ${({ main }) =>
    !main &&
    `
    width: 5rem;
    border: 0.2rem solid var(--primary-color);
    height: 5rem;
    background: white;
    margin-right: 1rem;
    margin-bottom: 1rem;
    border-radius: 1rem;
    transition: 0.3s ease-in-out opacity;

    &:hover {
      opacity: 0.8;
    }
  `}
`;

export const Thumbnails = styled.div`
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  & img {
    object-fit: cover;
  }
`;

export const AnimalDetailsContainer = styled.div`
  display: flex;
  ${breakpoints.smMax`
    display: block;
  `}
`;
